<template>
    <div>
        <div class="mb-3" v-if="$route.params.id">
            <a href="#" class="text-reset" @click.prevent="closeReplies()">
                <h4>
                    <i class="fas fa-arrow-left"></i>
                    戻る
                </h4>
            </a>
        </div>
        <div class="news" ref="news">
            <div class="mb-3" v-if="fixed">
                <i class="fas fa-thumbtack"></i> 固定
            </div>
            <div class="filtered" v-if="isFilter(news)" @click="showR18()">
                <span class="badge badge-danger">R18</span>
            </div>
            <div class="news-body" v-if="news.image">
                <div v-html="$filters.url(news.body)"></div>
                <div class="d-flex justify-content-center">
                    <img :src="news.image" class="img-fluid img-news pointer" @click="showImage(news.image)">
                </div>
            </div>
            <div class="news-body" v-else-if="getUrl(news.body)">
                <div v-html="$filters.url(news.body, true)"></div>
                <ogp-pane class="my-3" :url="getUrl(news.body)" :small="true"></ogp-pane>
            </div>
            <div class="news-body" v-html="$filters.ruby(news.body)" v-else-if="!news.review_id"></div>
            <div v-else>
                <div class="badge bagde-pills badge-info" v-if="news.review.applause">
                    <h6 class="m-0">{{news.review.applause.caption}}</h6>
                </div>
                <div class="news-body my-3" v-html="$filters.wrap(news.review.body)"></div>
                <div class="small text-right" v-if="news.review.book">
                    <router-link :to="`/author/book/${news.review.book.id}`">
                        ――{{news.review.book.title}}
                        <span v-if="news.review.section">
                            「{{news.review.section.section_name}}」
                        </span>
                    </router-link>
                </div>
                <hr>
                <h6>返信</h6>
                <div class="news-body" v-html="$filters.wrap(news.review.reply)"></div>
            </div>
            <div class="text-muted d-flex justify-content-end small">
                <div class="mr-2">
                    <a href="#" @click.prevent="closeReplies()" v-if="$route.params.id">
                        <i class="fas fa-comment-slash"></i>
                        返信
                        <span class="badge badge-pill badge-primary" v-if="replies.length">{{ replies.length }}</span>
                    </a>
                    <a href="#" @click.prevent="openReplies()" v-else>
                        <i class="far fa-comment"></i>
                        返信
                        <span class="badge badge-pill badge-primary" v-if="news.replies_count">{{ news.replies_count }}</span>
                    </a>
                </div>
                <div class="pointer text-danger mr-2" @click="like(news.id)">
                    <heart :likes="news.likes"></heart>
                    <span v-if="news.likes">
                        {{ news.likes }}
                    </span>
                </div>
                <span class="badge mr-2 badge-rating" :class="[ratingBadge(news.rating)]" v-if="news.rating_id">
                    {{news.rating.rating_name}}
                </span>
                {{$filters.dateFormat(news.created_at , 'YYYY-MM-DD HH:mm')}}
            </div>
            <vue-easy-lightbox :imgs="imgs" :visible="showLightbox" @hide="hideImage()"></vue-easy-lightbox>
        </div>
        <transition mode="out-in">
            <div v-if="$route.params.id" class="mt-2 mb-5">
                <div class="reply" v-for="r in replies">
                    <div v-if="!r.is_allowed">
                        この返信は承認待ちです。
                    </div>
                    <div v-else>
                        <div class="news-body" v-html="$filters.url(r.body)"></div>
                        <div class="d-flex justify-content-center" v-if="r.image">
                            <img :src="r.image" class="img-fluid img-news pointer" @click="showImage(r.image)">
                        </div>
                        <div class="d-flex justify-content-center" v-if="getUrl(r.body)">
                            <ogp-pane class="my-3" :url="getUrl(r.body)" :small="true"></ogp-pane>
                        </div>
                        <div class="text-muted small d-flex justify-content-end">
                            <div class="pointer text-danger mr-2" @click="likeReply(r.id)">
                                <heart :likes="r.likes"></heart>
                                <span v-if="r.likes">
                                    {{ r.likes }}
                                </span>
                            </div>
                            <div class="mr-2">
                                {{ r.name }}
                            </div>
                            <div>
                                {{$filters.dateFormat(r.created_at , 'YYYY-MM-DD HH:mm')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="reply-form" v-if="$store.state.max_replies > replies.length">
                    <input type="text" class="form-control mb-1" v-model="reply.name"
                        maxlength="80"
                        placeholder="お名前">
                    <div class="text-pane">
                        <div class="text-pane-dummy">{{reply.body + '\u200b'}}</div>
                        <textarea class="text-pane-editor"
                            maxlength="250"
                            v-model="reply.body"
                            @keydown.ctrl.enter="postReply()"
                            @keydown.meta.enter="postReply()"
                            :placeholder="placeholder"></textarea>
                    </div>
                    <div class="d-flex justify-content-between post-button-pane">
                        <div class="flex-fill mr-2">
                            <button class="btn btn-primary btn-sm btn-block mr-2" :disabled="!available" @click="postReply()">
                                投稿
                            </button>
                        </div>
                        <div class="length-graph">
                            <circle-graph
                                :value="replyLength"></circle-graph>
                        </div>
                    </div>
                    <div v-if="getUrl(reply.body)" class="my-3">
                        <ogp-pane :url="getUrl(reply.body)"></ogp-pane>
                    </div>
                    <div class="small text-center">
                        {{ replies.length }} /
                        <span v-if="$store.state.max_replies">{{ $store.state.max_replies }}</span>
                        件
                    </div>
                </div>
                <div class="reply-form" v-else>
                    返信の最大数に達しました。
                </div>
            </div>
        </transition>
    </div>
</template>

<style scoped lang="scss">
.news {
    width: 100%;
    margin: .5rem 0;
    padding: .9rem;
    font-size: .9rem;
    border: 1px solid #aaa;
    border-radius: .4rem;
    position: relative;
    overflow: hidden;
}
.news-body {
    overflow: hidden;
}
.length-graph {
    width: 28px;
    height: 28px;
}
.badge {
    vertical-align: middle;
}
.reply {
    width: 100%;
    margin: 1.5rem 0 .5rem;
    padding: .9rem;
    font-size: .9rem;
    border: 0;
    border-radius: .4rem;
    background-color: rgba(200, 200, 200, .2);
    position: relative;
    overflow: visible;
    &:before {
        content: "";
        position: absolute;
        top: -30px;
        left: 50%;
        margin-left: -15px;
        border: 15px solid transparent;
        border-bottom: 15px solid rgba(200, 200, 200, .2);
    }
}
.reply-form {
    width: 100%;
    margin: 1.5rem 0 .5rem;
    padding: .9rem;
    font-size: .85rem;
    border: 0;
    border-radius: .4rem;
    background-color: rgba(127, 127, 127, .2);
    position: relative;
    overflow: visible;
    &:before {
        content: "";
        position: absolute;
        top: -30px;
        left: 50%;
        margin-left: -15px;
        border: 15px solid transparent;
        border-bottom: 15px solid rgba(127, 127, 127, .2);
    }
}
.img-news {
    margin: 1rem 0;
    border-radius: .4rem;
}
.badge-rating {
    padding-top: 0.3rem;
}
.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 0px;
    border-radius: 4px;
    margin: 0 auto .5rem;
    font-size: 0.85rem;
    line-height: 1.8rem;
    .text-pane-dummy {
        overflow: hidden;
        box-sizing: border-box;
        min-height: 120px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
        border-radius: 4px;
        opacity: 0;
        padding: 0.375rem 0.8rem;
    }
    .text-pane-editor {
        position: absolute;
        top: 0;
        left: 0;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        padding: 0.375rem 0.8rem;
        &:focus {
            outline: none;
        }
        border-radius: 4px;
    }
}
.post-button-pane {
    height: 2rem;
}
</style>

<script>
import circleGraph from "components/circleGraph.vue"
import ogpPane from "components/Ogp";
import heart from "components/Heart";
export default {
    components: {
        ogpPane,
        circleGraph,
        heart,
    },
    props: {
        news: {
            required: true,
        },
        fixed: {
            default: false,
        },
    },
    data() {
        return {
            imgs: [],
            showLightbox: false,
            reply: {
                news_id: null,
                name: null,
                body: "",
            },
            isLoading: false,
            replies: [],
            scrollTop: null,
        }
    },
    methods: {
        ratingBadge(rating) {
            return "badge-" + rating.color;
        },
        like(id) {
            axios.post("/author/news/like", {id: id}).then(res => {
            }).catch(err => { alert.err(err) });
        },
        getUrl(body) {
            const matches = body.match(/(https?:\/\/[\w!?\/+\-_~;.,*&@#$%()'[\]]+)/g);
            if (matches) {
                return matches.pop();
            }
            return null;
        },
        isFilter(n) {
            if (n.rating?.rating_level >= 2 && !this.$store.state.user && !this.$store.state.r18) {
                return true;
            }
            return false;
        },
        showImage(src) {
            this.imgs = [];
            this.imgs.push(src);
            this.showLightbox = true;
        },
        hideImage() {
            this.showLightbox = false;
            this.img = [];
        },
        showR18() {
            this.$emit("showR18");
        },
        async load() {
            const loader = await this.__load();
            this.replies = loader.data;
        },
        __load() {
            return axios.get("/author/news/replies", {params: {id: this.news.id}});
        },
        async openReplies() {
            const loader = await this.__load();
            this.replies = loader.data;
            this.connectChannel();
            this.scrollTop = document.documentElement.scrollTop;
            this.$router.push(`/news/${this.news.id}`);
            setTimeout(() => {
                this.$emit("opened", this.news.id);
                const offsetTop = this.$refs.news.getBoundingClientRect().top + window.scrollY - 100;
                setTimeout(() => {
                    $("html,body").animate({scrollTop: offsetTop}, 300);
                });
            });
            const name = this.$cookie.get('name');
            if (name) {
                this.reply.name = name;
            }
        },
        closeReplies() {
            this.leaveChannel();
            setTimeout(() => {
                this.$emit("closed");
                this.$router.push(`/`);
                setTimeout(() => {this.$emit("load", this.scrollTop)});
            });
        },
        postReply() {
            if (this.isLoading) return;
            this.isLoading = true;
            this.reply.news_id = this.news.id;
            axios.post("/author/news/reply", this.reply).then(res => {
                alert.msg(res.data);
                this.reply.body = "";
                this.isLoading = false;
            }).catch(err => {
                alert.err(err);
                this.isLoading = false;
            });
        },
        likeReply(id) {
            axios.post("/author/news/reply/like", {id: id}).then(res => {
            }).catch(err => { alert.err(err) });
        },
        connectChannel() {
            if (Echo.connector.channels["news." + this.news.id]) {
                this.leaveChannel();
                setTimeout(() => {this.connectChannel()}, 400);
                return;
            }
            Echo.channel("news." + this.news.id).listen("News\\ReplyUpdate", (e) => {
                this.load();
            });
        },
        leaveChannel() {
            Echo.leaveChannel("news." + this.news.id);
        },
    },
    computed: {
        available() {
            if (this.reply.name && this.reply.body && !this.isLoading) {
                 return true;
            }
            return false;
        },
        replyLength() {
            return this.reply.body.length / 250 * 100;
        },
        placeholder() {
            if (this.$store.state.user && this.$store.state.user.id == this.news.user_id) {
                return "返信";
            } else {
                return "返信（作者が承認するまで表示されません）";
            }
        }
    },
    mounted() {
        if (this.$store.state && this.$store.state.user) {
            this.reply.name = this.$store.state.user.name || null;
        }
        if (this.$route.params.id) {
            this.openReplies();
        }
    },
    unmount() {
        this.leaveChannel();
    },
}
</script>